import {
  FacebookSvg,
  InstagramSvg,
  OdnoklassnikiSvg,
  TikTokSvg,
  TwitterSvg,
  VKontakteSvg,
  YouTubeSvg,
} from "@crunchyroll/cx-web-components";
import { useIntl } from "react-intl";
import FooterItem from "../FooterItem";
import FooterSection from "../FooterSection";
import { useIsCisCountry } from "../../../features/localization/hooks/country";

const FooterSocialsSection = ({ className = "" }) => {
  const intl = useIntl();
  const isCisCountry = useIsCisCountry();

  return (
    <FooterSection titleId="footer.connect_with_us" className={className}>
      <FooterItem
        messageId="footer.youtube"
        href={intl.formatMessage({ id: "footer.social.youtube_link" })}
        icon={YouTubeSvg}
        isNewTab
      />
      <FooterItem
        messageId="footer.facebook"
        href={intl.formatMessage({ id: "footer.social.facebook_link" })}
        icon={FacebookSvg}
        isNewTab
      />
      <FooterItem
        messageId="footer.twitter"
        href={intl.formatMessage({ id: "footer.social.twitter_link" })}
        icon={TwitterSvg}
        isNewTab
      />
      <FooterItem
        messageId="footer.instagram"
        href={intl.formatMessage({ id: "footer.social.instagram_link" })}
        icon={InstagramSvg}
        isNewTab
      />
      <FooterItem
        messageId="footer.tiktok"
        href={intl.formatMessage({ id: "footer.social.tiktok_link" })}
        icon={TikTokSvg}
        isNewTab
      />
      {isCisCountry && (
        <>
          <FooterItem
            messageId="footer.vkontakte"
            href="https://vk.com/crunchyroll"
            icon={VKontakteSvg}
            isNewTab
          />
          <FooterItem
            messageId="footer.odnoklassniki"
            href="https://ok.ru/crunchyroll"
            icon={OdnoklassnikiSvg}
            isNewTab
          />
        </>
      )}
    </FooterSection>
  );
};

export default FooterSocialsSection;
